export const formatPhoneKR = (raw) => {
  let digits = (raw || "").replace(/\D/g, "");
  if (digits.length === 10 && digits.startsWith("1")) digits = "0" + digits;
  if (digits.length > 11) digits = digits.slice(0, 11);
  if (digits.length <= 3) return digits;
  if (digits.length <= 7) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7, 11)}`;
};
